/**
 * @fileoverview gRPC-Web generated client stub for com.smartcloudsolutions.tollingvision
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.27.2
// source: TollingVisionService.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as TollingVisionService_pb from './TollingVisionService_pb'; // proto import: "TollingVisionService.proto"


export class TollingVisionServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorsearch = new grpcWeb.MethodDescriptor(
    '/com.smartcloudsolutions.tollingvision.TollingVisionService/search',
    grpcWeb.MethodType.SERVER_STREAMING,
    TollingVisionService_pb.SearchRequest,
    TollingVisionService_pb.SearchResponse,
    (request: TollingVisionService_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    TollingVisionService_pb.SearchResponse.deserializeBinary
  );

  search(
    request: TollingVisionService_pb.SearchRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<TollingVisionService_pb.SearchResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.smartcloudsolutions.tollingvision.TollingVisionService/search',
      request,
      metadata || {},
      this.methodDescriptorsearch);
  }

  methodDescriptoranalyze = new grpcWeb.MethodDescriptor(
    '/com.smartcloudsolutions.tollingvision.TollingVisionService/analyze',
    grpcWeb.MethodType.SERVER_STREAMING,
    TollingVisionService_pb.EventRequest,
    TollingVisionService_pb.EventResponse,
    (request: TollingVisionService_pb.EventRequest) => {
      return request.serializeBinary();
    },
    TollingVisionService_pb.EventResponse.deserializeBinary
  );

  analyze(
    request: TollingVisionService_pb.EventRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<TollingVisionService_pb.EventResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.smartcloudsolutions.tollingvision.TollingVisionService/analyze',
      request,
      metadata || {},
      this.methodDescriptoranalyze);
  }

  methodDescriptorstatus = new grpcWeb.MethodDescriptor(
    '/com.smartcloudsolutions.tollingvision.TollingVisionService/status',
    grpcWeb.MethodType.UNARY,
    TollingVisionService_pb.ServerStatusRequest,
    TollingVisionService_pb.ServerStatusResponse,
    (request: TollingVisionService_pb.ServerStatusRequest) => {
      return request.serializeBinary();
    },
    TollingVisionService_pb.ServerStatusResponse.deserializeBinary
  );

  status(
    request: TollingVisionService_pb.ServerStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<TollingVisionService_pb.ServerStatusResponse>;

  status(
    request: TollingVisionService_pb.ServerStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: TollingVisionService_pb.ServerStatusResponse) => void): grpcWeb.ClientReadableStream<TollingVisionService_pb.ServerStatusResponse>;

  status(
    request: TollingVisionService_pb.ServerStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: TollingVisionService_pb.ServerStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/com.smartcloudsolutions.tollingvision.TollingVisionService/status',
        request,
        metadata || {},
        this.methodDescriptorstatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/com.smartcloudsolutions.tollingvision.TollingVisionService/status',
    request,
    metadata || {},
    this.methodDescriptorstatus);
  }

  methodDescriptorwatch = new grpcWeb.MethodDescriptor(
    '/com.smartcloudsolutions.tollingvision.TollingVisionService/watch',
    grpcWeb.MethodType.SERVER_STREAMING,
    TollingVisionService_pb.LicenseServiceStatusRequest,
    TollingVisionService_pb.LicenseServiceStatusResponse,
    (request: TollingVisionService_pb.LicenseServiceStatusRequest) => {
      return request.serializeBinary();
    },
    TollingVisionService_pb.LicenseServiceStatusResponse.deserializeBinary
  );

  watch(
    request: TollingVisionService_pb.LicenseServiceStatusRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<TollingVisionService_pb.LicenseServiceStatusResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.smartcloudsolutions.tollingvision.TollingVisionService/watch',
      request,
      metadata || {},
      this.methodDescriptorwatch);
  }

}

